import { z } from 'zod';

/**
 * Schema do form de Férias.
 *
 * Regras (card [vWqWv5OC] T-22):
 * - `dataInicio`/`dataFim` ISO `YYYY-MM-DD`.
 * - `dataFim >= dataInicio` (validação client-side; server também valida).
 * - `observacao` texto livre opcional.
 * - Anti-sobreposição é validada apenas no server (precisa conhecer outros
 *   períodos do colaborador) — UI exibe o 409 via toast.
 *
 * PK é `dataInicio`; em Edit fica disabled.
 */
const dateRe = /^\d{4}-\d{2}-\d{2}$/;

export const employeeFeriasInputSchema = z
  .object({
    dataInicio: z.string().regex(dateRe, 'Data inválida (use AAAA-MM-DD)'),
    dataFim: z.string().regex(dateRe, 'Data inválida (use AAAA-MM-DD)'),
    observacao: z.string().max(500, 'Máximo 500 caracteres'),
  })
  .superRefine((v, ctx) => {
    if (v.dataInicio && v.dataFim && v.dataFim < v.dataInicio) {
      ctx.addIssue({
        path: ['dataFim'],
        code: 'custom',
        message: 'Data fim deve ser maior ou igual à data de início.',
      });
    }
  });

export type EmployeeFeriasFormValues = z.infer<typeof employeeFeriasInputSchema>;
